import { styled } from '@mui/material/styles';
import { TableRow } from '@mui/material';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: '#f8fafc',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
